import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { X, QrCode, Loader2 } from 'lucide-react';
import { shareCatalog, QR_PREFIX } from '../lib/catalogShare';

export default function CatalogShare({ t, onClose }) {
  const [res, setRes] = useState(null);
  const [qr, setQr] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    shareCatalog().then(async (r) => { setRes(r); setQr(await QRCode.toDataURL(QR_PREFIX + r.code, { width: 520, margin: 2, errorCorrectionLevel: 'M' })); }).catch(() => setErr(true));
  }, []);
  return createPortal(
    <div className="editor-backdrop" data-testid="catalog-share-dialog">
      <div className="editor cat-share">
        <div className="editor-head">
          <h4><QrCode size={18} /> {t.catShareTitle}</h4>
          <button className="icon-btn" data-testid="catalog-share-close-btn" onClick={onClose}><X size={16} /></button>
        </div>
        {err && <div className="empty" data-testid="catalog-share-error">{t.catShareErr}</div>}
        {!err && !qr && <div className="empty"><Loader2 className="spin" size={22} /></div>}
        {qr && (
          <>
            <img className="share-qr" src={qr} alt="QR" data-testid="catalog-share-qr" />
            <div className="share-code" data-testid="catalog-share-code">{res.code}</div>
            <p className="muted small-hint" data-testid="catalog-share-info">{res.count} {t.catShareItems} · {t.catShareHint}</p>
          </>
        )}
      </div>
    </div>,
    document.body,
  );
}
